import React from "react";

import Button from "./Button";

type Props = {
  searchQuery: string;
  onClearSearch: () => void;
};

export default function SearchEmptyState({
  searchQuery,
  onClearSearch,
}: Props) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
      <p className="text-lg font-medium text-gray-900 mb-2">
        No se pudo encontrar &ldquo;{searchQuery}&rdquo;
      </p>
      <p className="text-sm text-gray-500 mb-4">
        Verifica que todo esté bien escrito o prueba con otras palabras clave.
      </p>
      <Button text="Limpiar búsqueda" onClick={onClearSearch} small narrow />
    </div>
  );
}
